<template>
  <div class="create-post-drawer"
       v-if="drawer">
    <el-drawer :title="setTitlt"
               :visible.sync="drawer"
               :wrapperClosable="false"
               :close-on-press-escape="false"
               direction="rtl"
               @close="colseDrawer">
      <div class="base">
        <el-form ref="form"
                 :model="form"
                 :inline="true"
                 :rules="rules"
                 label-width="80px"
                 size="mini"
                 v-enterToNext="true">
          <el-form-item label="公司名称"
                        prop="enterpriseId">
            {{form.enterpriseShortName}}
          </el-form-item>
          <el-form-item label="计划">
            {{form.projectName}}
          </el-form-item>
          <el-form-item label="职位名称"
                        prop="positionName">
            {{form.positionName}}
          </el-form-item>

          <el-form-item label="职位类别"
                        prop="positionType">
            {{form.positionType}}

          </el-form-item>
          <!-- <el-form-item label="排序">
            <el-input-number v-model="form.sort"
                             :precision="0"></el-input-number>
          </el-form-item> -->
          <el-form-item label="薪资类型"
                        prop="remunerationType">
            {{form.remunerationType==1?'日薪':form.remunerationType==2?'周薪':form.remunerationType==3?'月薪':form.remunerationType==4?'小时工资':'计件工资'}}

          </el-form-item>
          <el-form-item label="公共职位">
            {{form.isPublic ? '是' : '否'}}
          </el-form-item>
          <div>
            <el-form-item label="职位生效"
                          prop="dateTimeFrom">
              {{form.dateTimeFrom && form.dateTimeFrom.slice(0, 10)}}
            </el-form-item>

            <!-- 职位结束日期（限制：必须大于开始日期） -->
            <el-form-item label="职位结束"
                          prop="dateTimeTo">
              {{form.dateTimeTo && form.dateTimeTo.slice(0, 10)}}
            </el-form-item>

            <!-- <el-form-item label="招聘人数">
              {{form.num}}
            </el-form-item> -->
            <!-- <el-form-item label="到期时间">
              <el-date-picker v-model="form.value1"
                              type="datetime"
                              placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item> -->

            <el-form-item label="收入">
              {{form.remunerationLevel }} {{remunerationTypeJudge(form.remunerationType)}}
            </el-form-item>
            <el-form-item label="福利标签">
              {{form.label}}
            </el-form-item>

            <!-- <el-form-item label="招聘人数">
              <el-input-number v-model="form.welfareLabel"
                               @change="handleNumChange"
                               :min="1"
                               label="描述文字"></el-input-number>
            </el-form-item> -->

            <el-form-item label="性别要求">
              {{form.gender}}
              <!-- <el-input v-model="form.sex" maxlength="30"> </el-input> -->
            </el-form-item>
            <el-form-item label="年龄要求"
                          prop="age">

              <div v-if="form.age">{{form.age[0]}} - {{form.age[1]}}岁 </div>
            </el-form-item>
            <div style="overflow: hidden">

              <el-col :span="24">
                <el-form-item label="职位描述"
                              class="form-item-block">
                  <div v-html="form.jobDescribe">

                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="职位要求"
                              class="form-item-block">
                  <div v-html="form.jobRequirements">

                  </div>

                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="福利待遇"
                              class="form-item-block">
                  <div v-html="form.jobBenefits">

                  </div>
                </el-form-item>
              </el-col>
            </div>
          </div>
        </el-form>
      </div>
      <div class="rightPadding"></div>
      <div class="submit-bar">
        <el-button @click="
            () => {
              colseDrawer();
            }
          ">取 消</el-button>
        <el-button type="primary"
                   :disabled="form.applyStatus"
                   :loading="submitLoading"
                   @click="onSubmit('form')">{{form.applyStatus ? '已报名' : '报 名'}}
        </el-button>
      </div>
    </el-drawer>
    <el-dialog title="新增职位类型"
               :visible.sync="addCategoryDrawerShow"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="500px"
               class="colleague-dialog"
               @close="resetForm">
      <el-form ref="CategoryForm"
               :model="CategoryForm"
               :rules="rules"
               label-width="80px">
        <el-form-item label="类别名称"
                      prop="name">
          <el-input v-model="CategoryForm.name"></el-input>
        </el-form-item>

        <el-form-item label="排序"
                      class="number-footer">
          <el-input-number v-model="CategoryForm.sort"
                           :precision="0"></el-input-number>
        </el-form-item>

        <!-- <el-form-item label="是否管理员">
          <el-switch v-model="form.isManage"></el-switch>
        </el-form-item> -->
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="
            () => {
              resetForm();
              addCategoryDrawerShow = false;
            }
          ">取 消</el-button>
        <el-button size="small "
                   type="primary"
                   :loading="submitLoading"
                   @click="addCategory('CategoryForm')">确 定</el-button>
      </span>
    </el-dialog>
    <jobMacting :visible="jobMactingVisible"
                @close="(jobMactingVisible = false), (items = [])"
                :posName="form.position"
                type="1"
                :industry="industry"
                @enter="enter"></jobMacting>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import InputNumberRange from "@/components/InputNumberRange.vue";
import jobMacting from "@/components/jobMatching";
import { posTypes } from "@/utils/common"
export default {
  components: {
    VueUeditorWrap,
    InputNumberRange,
    jobMacting,
  },
  props: {
    users: Array,
    drawerShow: Boolean,
    postInfo: Object,
    operation: String,
    companyId: String,
    cityList: Array,
  },
  data () {
    let validateage = (rule, value, callback) => {
      if (value == undefined) {
        callback();
        return;
      }
      if (value[0] == null && value[1] == null) {
        callback();
      }
      if (!value[0] || !value[1]) {
        callback(new Error("请输入完整"));
      } else {
        callback();
      }
    };
    return {
      myConfig: {
        // 设置编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 280,
        // 初始容器宽度
        initialFrameWidth: "100%",

        // UEditor 是文件的存放路径，
        UEDITOR_HOME_URL: "/Ueditor/",
      },
      value: "",
      pushType: 3,
      CategoryForm: {},
      submitLoading: false,
      drawer: false,
      addCategoryDrawerShow: false,
      postStateList: [],
      salaryLevel: [],
      form: {
        state: 1,
        num: 1,
        participant: [],
        participantName: [],
        recruitingNum: 1,
        remunerationType: '',
        isPublic: true,
      },
      startDatePickerOptions: {
        disabledDate: (date) => {
          // 未选择结束日期时，不限制（可根据需求调整）
          if (!this.form.dateTimeTo) return false;

          // 转换结束日期为 Date 对象，清除时间部分
          const endDate = new Date(this.form.dateTimeTo);
          endDate.setHours(0, 0, 0, 0);

          // 禁用：结束日期及之后的所有日期（确保开始 < 结束）
          return date.getTime() >= endDate.getTime();
        }
      },
      // 结束日期选择器配置：禁用 <= 开始日期的日期
      endDatePickerOptions: {
        disabledDate: (date) => {
          // 未选择开始日期时，不限制（可根据需求调整）
          if (!this.form.dateTimeFrom) return false;

          // 转换开始日期为 Date 对象，清除时间部分
          const startDate = new Date(this.form.dateTimeFrom);
          startDate.setHours(0, 0, 0, 0);

          // 禁用：开始日期及之前的所有日期（确保结束 > 开始）
          return date.getTime() <= startDate.getTime();
        }
      },

      rules: {

      },
      jobNatureList: [],
      demandTypeList: [],
      postId: "",
      disabled: false,
      companyList: [],
      workExperience: [],
      positionList: posTypes,
      jobMactingVisible: false,
      industry: "",
      projectList: [],
    };
  },
  mounted () { },
  computed: {
    setTitlt () {
      return this.operation === "edit" ? "查看职位信息" : "查看职位信息";
    },
  },
  methods: {
    handleDateChange () {
      const { dateTimeFrom, dateTimeTo } = this.form;
      // 两个日期都已选择时才校验
      if (dateTimeFrom && dateTimeTo) {
        const start = new Date(dateTimeFrom);
        const end = new Date(dateTimeTo);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        // 如果开始 >= 结束，清空后选择的那个日期（谁后变就清空谁）
        // 这里简化逻辑：直接清空结束日期（也可根据业务调整为清空开始日期）
        if (start >= end) {
          this.form.dateTimeTo = '';
          // 若想清空开始日期，可改为：this.form.dateTimeFrom = '';
        }
      }
    },
    //薪资类型的判断
    remunerationTypeJudge () {
      if (this.form.remunerationType) {
        switch (this.form.remunerationType) {
          case 1:
            return '元/日';
          case 2:
            return '元/周';
          case 3:
            return '元/月';
          case 4:
            return '元/时';
          case 5:
            return '元/件';
          default:
            return '元';
        }
      }
      else {
        return '元';
      }
    },
    // 同步标准职位
    enter (value, name) {
      this.form.standardName = value.standardName;
      this.form.standardRank = value.standardRank;
      this.form.occupationCode = value.occupationCode;
      this.$set(this.form, "position", name);
      // console.log(value);
    },
    addCategory (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitLoading = true;

          let sendData = {
            name: this.CategoryForm.name,
            sort: this.CategoryForm.sort,
          };
          this.$api.posts
            .PositionTypeEdit(JSON.stringify(sendData))
            .then((res) => {
              if (res.error == false) {
                // this.getPositionList();
                this.addCategoryDrawerShow = false;
                this.$message.success("保存成功");
                this.submitLoading = false;
              }
            });
        } else {
          //就像用户提示发生错误的消息
        }
      });
    },
    handleChange (value) { },
    colseDrawer () {
      this.$refs["form"].resetFields();
      this.$emit("colseDrawer");
    },
    handleNumChange (val) {
      this.form.recruitingNum = val;
      console.log(this.form.recr);
    },
    resetForm () {
      this.CategoryForm = {};
      this.$refs.CategoryForm.clearValidate();
    },
    onSubmit () {
      let info = JSON.parse(window.localStorage.getItem("userInfo"));
      let sendData = {
        name: info.cname,
        phoneNumber: info.tel,
        applyList: [this.postInfo.id],
      }
      this.$api.IndividualUser.JobApply(sendData).then((res) => {
        this.colseDrawer();
        if (res.error === false) {
          this.$message.success("报名成功");
        } else {
          this.$message.success("该职位重复报名！");

        }
        this.submitLoading = false;
      });

    },
    turnNum (nums) {
      if (nums == ",") {
        return;
      }
      return nums.map(Number);
    },
    fillFormData (obj) {

      this.postId = obj.id;
      this.$set(this, 'form', obj)
      this.$set(this.form, "companyid", obj.customerId);
      this.$set(this.form, "position", obj.positionName);
      this.$set(this.form, "department", obj.department);
      this.$set(this.form, "num", obj.recruitingNum);
      this.$set(this.form, "startTime", obj.putForwardTime);
      this.$set(this.form, "endTime", obj.inductionTIme);
      this.$set(this.form, "jobNature", obj.jobCategory);
      this.$set(this.form, "demandType", obj.demandType);
      this.$set(this.form, "sex", obj.sex);
      this.$set(this.form, "projectId", obj.projectId);
      this.$set(this.form, "positionTypeId", obj.positionTypeId);
      this.$set(this.form, "city", obj.workCity && obj.workCity.split(","));
      this.$set(this.form, "isUrgency", obj.CriticalSituation);
      this.$set(this.form, "principalMan", obj.PrincipalId);
      this.$set(this.form, "age", obj.age && this.turnNum(obj.age.split(",")));
      this.$set(this.form, "HourlyWage", obj.hourlyWage);
      this.$set(this.form, "remunerationLevel", obj.remunerationLevel);
      this.$set(this.form, "remunerationType", Number(obj.remunerationType));
      this.$set(this.form, "weal", obj.weal);
      this.$set(this.form, "request", obj.request);
      this.$set(this.form, "sort", obj.sort);
      this.$set(this.form, "state", obj.state);
      this.$set(this.form, "label", obj.welfareLabel);
      this.$set(this.form, "desc", obj.jobDescribe);
      this.$set(this.form, "remark", obj.Remark);
      this.$set(this.form, "askForEducation", obj.AskForEducation);
      this.$set(this.form, "standardName", obj.standardName);
      this.$set(this.form, "standardRank", obj.standardRank);
      this.$set(this.form, "releaseType", obj.releaseType);
      this.$set(this.form, "isRelease", obj.isRelease);

    },

    //获取公司列表
    getCompanyList () {
      let sendData = {
        pageSize: -1,
      }
      this.$api.EnterpriseInfo.List(sendData).then((res) => {
        if (res.error === false) {
          this.companyList = res.data;
          // if (this.companyId) {
          // }
        }
      });
    },
    getProjectList () {
      let sendData = {
        pageSize: -1,
      }
      this.$api.ProjectInfo.List(sendData).then((res) => {
        if (res.error === false) {
          this.projectList = res.data;
        }
      });
    },
    // 获取职位类型
    getPositionList () {
      let sendData = {
        pageIndex: 1,
        pageSize: 1000,
      };
      this.$api.posts.PositionTypePage(sendData).then((res) => {

        if (res.error === false) {
          this.positionList = res.data.data;
        }
      });
    },
  },
  watch: {
    drawerShow (val) {
      this.drawer = val;
      if (val) {
        this.getCompanyList();
        // this.getPositionList();
        this.getProjectList();
      }
      if (this.drawer == false) {
        this.postId = "";
        if (val) {
          this.$nextTick(() => {
            this.$refs["form"].clearValidate();
          });
          return;
        }
      }
      console.log(this.operation);
      if (this.operation == "edit" && this.drawer) {
        this.fillFormData(this.postInfo);
      }
      if (this.operation == "add") {
        this.$set(this.form, "age", [null, null]);
        this.form = {
          state: 1,
          num: 1,
          participant: [],
          participantName: [],
          recruitingNum: 1,
          remunerationType: '',
          isPublic: true,
        }
        this.$forceUpdate();

      }
      if (this.companyId) {
        this.$set(this.form, "companyid", this.companyId);

        this.disabled = true;
      }
    },
  },
};
</script>

<style lang="less">
#input1 {
  width: 300px;
}
.create-post-drawer {
  .el-drawer {
    width: 78% !important;
    min-width: 1150px;

    .el-drawer__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 0;
      padding-bottom: 15px;
    }
    .el-drawer__body {
      // display: flex;
      background-color: rgba(0, 0, 0, 0.03);
    }
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: auto;
  }
  .el-date-editor--daterange.el-input__inner {
    width: auto;
  }
  .el-date-editor .el-range-separator {
    width: 10%;
  }
  .base {
    width: 80%;
    float: left;
    padding: 17px 50px 60px 50px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: #fff;

    .el-form-item {
      width: 48%;
      .el-form-item__content {
        width: 56%;
      }

      .el-select {
        width: 100%;
      }
    }
    .standardName {
      .el-form-item__content {
        width: auto;
      }
    }
    .minNum {
      .el-form-item__content {
        width: 50% !important;
      }
    }
    .code-input {
      .el-form-item__content {
        width: calc(85% - 55px);
      }
    }
    .form-item-block {
      width: 100%;
      .el-form-item__content {
        width: 90%;
      }
    }
    .foreign {
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px solid #dcdfe6;
    }
  }
  .tip {
    font-size: 12px;
    color: #909399;
  }
  .priceSetting {
    .el-form-item__content {
      width: 70% !important;
    }

    .bpttpmTip {
      display: flex;
      p {
        line-height: 1.6;
      }
    }
  }
  .el-divider__text.is-center {
    color: #66b1ff;
  }
  .block {
    display: block;
    .el-form-item__content {
      width: calc(100% - 80px);
    }
  }
}
// .post-form {
//   .el-input {
//     min-width: 280px;
//     max-width: 350px;
//   }
//   .el-input-number {
//     .el-input {
//       min-width: auto;
//     }
//   }
// }
.submit-bar {
  position: absolute;
  z-index: 99999999;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 0;
  background-color: #fff;
  text-align: center;
  border-top: 1px solid #ddd;
  padding-right: 20px;
  .el-button {
    padding: 8px 20px;
  }
}
</style>
